import { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../libs/contexts/authContext'
import { Navigate } from 'react-router'
import Notice from './NoticePage'

const DynamicView = ({ version1, version2, version3 }) => {
  const { company, authObj, productId } = useContext(AuthContext)

  const [showNotice, setShowNotice] = useState(false)

  useEffect(() => {
    if (company === '') {
      setTimeout(() => setShowNotice(true), 1500)
    }
  }, [company])

  if (company === 'foresters') return version2
  else if (company === 'avant') return version3
  else if (company === 'assure' || company === 'sbli') return version1
  else if (showNotice) return <Notice />
  else return <></>
}

export default DynamicView
